import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { Icon } from './icon.tsx'

export interface PageTitleProps {
  title: string
  description?: string
  backUrl?: string
  onBack?(): void
}

export const PageTitle = ({ title, description, backUrl, onBack }: PageTitleProps): React.ReactElement => {
  const showGoBackLink = backUrl || onBack
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        mb: { xs: 4, lg: 6 },
      }}
    >
      {showGoBackLink && (
        <Link
          {...(backUrl && { component: RouterLink, to: backUrl })}
          variant="body2"
          onClick={onBack}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            color: 'text.primary',
            mb: 1,
          }}
        >
          <Icon name="ArrowLeft" /> Назад
        </Link>
      )}
      <Typography variant="h2">{title}</Typography>
      {description && <Typography sx={{ mt: { xs: 2, lg: 3 } }}>{description}</Typography>}
    </Box>
  )
}
